import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-modal"
}
const _hoisted_2 = { class: "modal-crear" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "ayuda"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "ayuda" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "grupos-lista" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "info"
}
const _hoisted_13 = {
  key: 0,
  class: "banco"
}
const _hoisted_14 = { class: "seccion-head" }
const _hoisted_15 = { class: "banco-filtro" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "contador"
}
const _hoisted_18 = {
  key: 0,
  class: "info"
}
const _hoisted_19 = {
  key: 1,
  class: "info"
}
const _hoisted_20 = {
  key: 2,
  class: "info"
}
const _hoisted_21 = { class: "banco-select-todo" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = { class: "lista-banco" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "bq-texto" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "seccion" }
const _hoisted_28 = { class: "seccion-head" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "borrador-card"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "form-group"
}
const _hoisted_35 = {
  key: 1,
  class: "form-group"
}
const _hoisted_36 = { class: "radio-dest" }
const _hoisted_37 = { class: "radio-label" }
const _hoisted_38 = { class: "radio-label" }
const _hoisted_39 = {
  key: 0,
  class: "grupos-check-mini"
}
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "borrador-botones" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 1,
  class: "info"
}
const _hoisted_44 = { class: "pregunta-head" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "form-group"
}
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = {
  key: 1,
  class: "form-group"
}
const _hoisted_54 = { class: "radio-dest" }
const _hoisted_55 = { class: "radio-label" }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = { class: "radio-label" }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = {
  key: 0,
  class: "grupos-check-mini"
}
const _hoisted_60 = ["value", "onUpdate:modelValue"]
const _hoisted_61 = {
  key: 1,
  class: "resumen-grupos"
}
const _hoisted_62 = { class: "resumen-lista" }
const _hoisted_63 = {
  key: 0,
  class: "resumen-alerta"
}
const _hoisted_64 = { class: "botones" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]

import { ref, reactive, computed, watch } from 'vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionGrupoInteres } from '@/store/GestionGrupoInteres'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { getCatalogoInstrumentosService } from '@/services/InstrumentosService'
import type { CatalogoInstrumento, ModalidadInstrumento } from '@/interfaces/Instrumetos'

interface PreguntaNueva {
  enunciado: string
  tipo_respuesta: string
  opcionesTexto: string
  id_pregunta_origen?: number | null
  general: boolean
  gruposDestino: number[]
}

const OPCIONES_UNICA_DEFAULT = 'Plena o Completa\nAlta (o)\nAceptable\nBajo (a)\nNingún (a)'

/** Catálogo de tipos de pregunta que ofrece el modal. */

export default /*@__PURE__*/_defineComponent({
  __name: 'CrearFormularioModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["cerrar", "creado"],
  setup(__props: any, { emit: __emit }) {

/**
 * Creación del formulario de opinión.
 *
 * Al publicar se congela `preguntas_snapshot`: editar una pregunta después no
 * altera el formulario ya publicado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const instrumentoStore = useGestionInstrumento()
const grupoStore = useGestionGrupoInteres()
const preguntaStore = useGestionPreguntas()
const tipoStore = useGestionTipoComponente()

const TIPOS_CON_OPCIONES = ['opcion_unica', 'single_choice', 'multiple_choice', 'casillas']

const TIPOS_PREGUNTA = [
  { valor: 'opcion_unica', etiqueta: 'Opción única' },
  { valor: 'escala_likert', etiqueta: 'Escala Likert' },
  { valor: 'escala_lineal', etiqueta: 'Escala lineal' },
  { valor: 'multiple_choice', etiqueta: 'Casillas' },
  { valor: 'short_text', etiqueta: 'Respuesta corta' },
  { valor: 'long_text', etiqueta: 'Párrafo' }
]

const nombre = ref('')
const herramienta = ref('encuesta')
const modalidad = ref<ModalidadInstrumento>('por_pregunta')
const catalogo = ref<CatalogoInstrumento>({ herramientas: [], modalidades: [] })
const gruposSeleccionados = ref<number[]>([])
const grupoBancoActivo = ref<number | null>(null)
const preguntas = ref<PreguntaNueva[]>([])
const guardando = ref(false)
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const mostrandoBorrador = ref(false)
const borrador = reactive<PreguntaNueva>({ enunciado: '', tipo_respuesta: '', opcionesTexto: '', general: true, gruposDestino: [] })

// Banco de preguntas del grupo activo en el panel de banco
const banco = ref<any[]>([])
const bancoSeleccionado = ref<number[]>([])
const cargandoBanco = ref(false)

const grupos = computed(() => grupoStore.grupos ?? [])

/** Solo herramientas de opinión: esto arma formularios, no fichas documentales. */
const herramientasOpinion = computed(() =>
  catalogo.value.herramientas.filter(h => h.tipo_informacion === 'opinion')
)

const herramientaActual = computed(() =>
  herramientasOpinion.value.find(h => h.valor === herramienta.value)
)

const etiquetaHerramienta = computed(() => herramientaActual.value?.etiqueta ?? 'encuesta')

/** Vacío = la herramienta admite cualquier tipo de pregunta. */
const tiposPreguntaPermitidos = computed(() => herramientaActual.value?.tipos_pregunta ?? [])

const tiposDisponibles = computed(() => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return TIPOS_PREGUNTA
  return TIPOS_PREGUNTA.filter(t => permitidos.includes(t.valor))
})

/** Del banco solo entran las preguntas que la herramienta admite. */
const bancoCompatible = computed(() => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return banco.value
  return banco.value.filter(b => permitidos.includes(b.tipo_respuesta || b.tipo || ''))
})

const todosBancoSeleccionados = computed(() =>
  bancoCompatible.value.length > 0 &&
  bancoCompatible.value.every(b => bancoSeleccionado.value.includes(b.id_pregunta))
)

function toggleTodosBanco() {
  if (todosBancoSeleccionados.value) {
    bancoSeleccionado.value = []
  } else {
    bancoSeleccionado.value = bancoCompatible.value.map(b => b.id_pregunta)
  }
}

const puedeGuardar = computed(() =>
  !!nombre.value.trim() &&
  gruposSeleccionados.value.length > 0 &&
  preguntas.value.length > 0 &&
  preguntas.value.every(p =>
    p.enunciado.trim() && p.tipo_respuesta &&
    (!requiereOpciones(p.tipo_respuesta) || opcionesDe(p).length >= 2) &&
    (p.general || p.gruposDestino.length > 0)
  ) &&
  gruposSeleccionados.value.every(id => contarPreguntasPorGrupo(id) > 0)
)

function nombreGrupo(id: number): string {
  return grupos.value.find(g => g.id_grupo_interes === id)?.nombre ?? `#${id}`
}

function contarPreguntasPorGrupo(idGrupo: number): number {
  return preguntas.value.filter(p => p.general || p.gruposDestino.includes(idGrupo)).length
}

watch(
  () => props.visible,
  async (v) => {
    if (!v) return
    nombre.value = ''
    herramienta.value = 'encuesta'
    modalidad.value = 'por_pregunta'
    gruposSeleccionados.value = []
    grupoBancoActivo.value = null
    preguntas.value = []
    mensajeVisible.value = false
    mostrandoBorrador.value = false
    const [cat] = await Promise.all([
      getCatalogoInstrumentosService(),
      grupoStore.getGrupos?.().catch(() => null),
      tipoStore.getTipos?.()
    ])
    catalogo.value = cat
  }
)

/**
 * Al cambiar de herramienta se reencauzan las preguntas ya escritas al primer
 * tipo admitido: pasar a encuesta con preguntas de párrafo daría 422 al guardar.
 */
watch(herramienta, () => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return

  const porDefecto = tiposDisponibles.value[0]?.valor ?? permitidos[0]
  for (const p of preguntas.value) {
    if (!permitidos.includes(p.tipo_respuesta)) p.tipo_respuesta = porDefecto
  }
  if (mostrandoBorrador.value && !permitidos.includes(borrador.tipo_respuesta)) {
    borrador.tipo_respuesta = porDefecto
  }
  bancoSeleccionado.value = bancoSeleccionado.value.filter(id =>
    bancoCompatible.value.some(b => b.id_pregunta === id)
  )
})

watch(grupoBancoActivo, async (id) => {
  banco.value = []
  bancoSeleccionado.value = []
  if (!id) return

  cargandoBanco.value = true
  try {
    banco.value = await preguntaStore.getPreguntas({ banco: true, id_grupo_interes: id } as any) ?? []
  } finally {
    cargandoBanco.value = false
  }
})

function importarDelBanco() {
  for (const b of bancoCompatible.value) {
    if (!bancoSeleccionado.value.includes(b.id_pregunta)) continue

    const opciones = Array.isArray(b.opciones) ? b.opciones : []
    preguntas.value.push({
      enunciado: b.enunciado || b.pregunta || '',
      tipo_respuesta: b.tipo_respuesta || b.tipo || 'escala_likert',
      opcionesTexto: opciones.join('\n'),
      id_pregunta_origen: b.id_pregunta,
      general: true,
      gruposDestino: []
    })
  }
  bancoSeleccionado.value = []
}

function requiereOpciones(tipo: string): boolean {
  return TIPOS_CON_OPCIONES.includes(tipo)
}

function opcionesDe(p: PreguntaNueva): string[] {
  return p.opcionesTexto.split('\n').map(o => o.trim()).filter(Boolean)
}

watch(() => borrador.tipo_respuesta, (tipo) => {
  if (tipo === 'opcion_unica') borrador.opcionesTexto = OPCIONES_UNICA_DEFAULT
})

function alCambiarTipoPregunta(p: PreguntaNueva) {
  if (p.tipo_respuesta === 'opcion_unica') p.opcionesTexto = OPCIONES_UNICA_DEFAULT
}

function abrirBorrador() {
  borrador.enunciado = ''
  const tipo = tiposDisponibles.value.length === 1 ? tiposDisponibles.value[0].valor : ''
  borrador.tipo_respuesta = tipo
  borrador.opcionesTexto = tipo === 'opcion_unica' ? OPCIONES_UNICA_DEFAULT : ''
  borrador.general = true
  borrador.gruposDestino = []
  mostrandoBorrador.value = true
}

function confirmarBorrador() {
  preguntas.value.push({ ...borrador, gruposDestino: [...borrador.gruposDestino] })
  mostrandoBorrador.value = false
}

function cerrarBorrador() {
  mostrandoBorrador.value = false
}

/** El id del tipo "Opinión" se resuelve por nombre, no por número fijo. */
function idTipoOpinion(): number | null {
  const t = (tipoStore.tipos ?? []).find((x: any) => /opini/i.test(String(x.nombre ?? '')))
  return t?.id_tipo_componente ?? null
}

async function guardar() {
  if (!puedeGuardar.value) return

  const idTipo = idTipoOpinion()
  if (!idTipo) {
    mostrarMensaje('No se encontró el tipo de componente "Información de Opinión".')
    return
  }

  guardando.value = true
  mensajeVisible.value = false
  try {
    const instrumento = await instrumentoStore.crearInstrumento({
      id_tipo_componente: idTipo,
      tipo: herramienta.value,
      modalidad: modalidad.value,
      descripcion: nombre.value.trim()
    } as any)

    if (!instrumento?.id_instrumento) {
      mostrarMensaje('No se pudo crear el formulario.')
      return
    }

    // Sincronizar grupos ANTES de crear preguntas: el backend valida que el grupo
    // de cada pregunta esté en el pivote del instrumento (422 si no está).
    await instrumentoStore.asignarGrupos(instrumento.id_instrumento, gruposSeleccionados.value)

    let orden = 1
    for (const p of preguntas.value) {
      const datosBase = {
        enunciado: p.enunciado.trim(),
        pregunta: p.enunciado.trim(),
        tipo_respuesta: p.tipo_respuesta,
        tipo: p.tipo_respuesta,
        opciones: opcionesDe(p),
        id_indicador: null,
      }

      // Para preguntas nuevas (sin origen) guardar una copia en el banco por
      // cada grupo al que aplica, para que futuros formularios puedan reutilizarlas.
      let idPreguntaOrigen = p.id_pregunta_origen ?? null
      if (!idPreguntaOrigen) {
        const gruposParaBanco = p.general ? gruposSeleccionados.value : p.gruposDestino
        for (const idGrupo of gruposParaBanco) {
          const copia = await preguntaStore.crearPregunta({
            ...datosBase,
            id_instrumento: null as any,
            id_grupo_interes: idGrupo,
            id_pregunta_origen: null,
            orden: 0,
          })
          if (copia?.id_pregunta && !idPreguntaOrigen) {
            idPreguntaOrigen = copia.id_pregunta
          }
        }
      }

      const base = {
        ...datosBase,
        id_instrumento: instrumento.id_instrumento,
        id_pregunta_origen: idPreguntaOrigen,
      }

      if (p.general) {
        const resultado = await preguntaStore.crearPregunta({ ...base, id_grupo_interes: null, orden: orden++ })
        if (!resultado) {
          mostrarMensaje('Error al crear la pregunta general.')
          return
        }
      } else {
        for (const idGrupo of p.gruposDestino) {
          const resultado = await preguntaStore.crearPregunta({ ...base, id_grupo_interes: idGrupo, orden: orden++ })
          if (!resultado) {
            mostrarMensaje(`Error al crear pregunta para "${nombreGrupo(idGrupo)}".`)
            return
          }
        }
      }
    }

    emit('creado', `Formulario creado con ${preguntas.value.length} pregunta(s).`)
    emit('cerrar')
  } catch (e: any) {
    mostrarMensaje(e?.message ?? 'Error al crear el formulario.')
  } finally {
    guardando.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "modal-titulo" }, "Crear formulario", -1)),
          _cache[38] || (_cache[38] = _createElementVNode("p", { class: "nota" }, " El formulario se crea suelto, con sus preguntas. Después se vincula desde los indicadores de opinión; cómo se reparte y cómo se califica depende del tipo y de la modalidad que elijas aquí. ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "nombre-form" }, "Nombre del formulario", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "nombre-form",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombre).value = $event)),
              type: "text",
              placeholder: "Encuesta de satisfacción 2026"
            }, null, 512), [
              [_vModelText, nombre.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "tipo-form" }, "Tipo de instrumento", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "tipo-form",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((herramienta).value = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(herramientasOpinion.value, (h) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: h.valor,
                  value: h.valor
                }, _toDisplayString(h.etiqueta), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, herramienta.value]
            ]),
            (tiposPreguntaPermitidos.value.length)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, " Una " + _toDisplayString(etiquetaHerramienta.value.toLowerCase()) + " se lee por porcentaje de cumplimiento por opción, así que solo admite preguntas de opción única. ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "modalidad-form" }, "¿Cómo califica?", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "modalidad-form",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalidad).value = $event))
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("option", { value: "por_pregunta" }, "Cada pregunta califica un indicador", -1),
              _createElementVNode("option", { value: "formulario_completo" }, "El formulario completo califica un indicador", -1)
            ]), 512), [
              [_vModelSelect, modalidad.value]
            ]),
            _createElementVNode("small", _hoisted_8, [
              (modalidad.value === 'por_pregunta')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" El formulario es compartido: al vincularlo se eligen qué preguntas le corresponden a cada indicador, y su nota es el promedio de esas preguntas. ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" El formulario entero evalúa un solo indicador: al vincularlo va completo, se califica con una sola nota y sus resultados se leen respuesta por respuesta. ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Grupos de interés *", -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupos.value, (g) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: g.id_grupo_interes,
                  class: "grupo-check"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: g.id_grupo_interes,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gruposSeleccionados).value = $event))
                  }, null, 8, _hoisted_11), [
                    [_vModelCheckbox, gruposSeleccionados.value]
                  ]),
                  _createTextVNode(" " + _toDisplayString(g.nombre), 1)
                ]))
              }), 128)),
              (!grupos.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Cargando grupos…"))
                : _createCommentVNode("", true)
            ])
          ]),
          (gruposSeleccionados.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[20] || (_cache[20] = _createElementVNode("h5", null, "Banco de preguntas", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((grupoBancoActivo).value = $event)),
                      class: "banco-grupo-select"
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "— Elegir grupo —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSeleccionados.value, (id) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: id,
                          value: id
                        }, _toDisplayString(nombreGrupo(id)), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, grupoBancoActivo.value]
                    ]),
                    (grupoBancoActivo.value && bancoCompatible.value.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(bancoCompatible.value.length), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!grupoBancoActivo.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Selecciona un grupo para ver su banco."))
                  : (cargandoBanco.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Cargando banco…"))
                    : (!bancoCompatible.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                          (banco.value.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Las preguntas del banco de este grupo no son de opción única, así que no caben en una " + _toDisplayString(etiquetaHerramienta.value.toLowerCase()) + ". ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" No hay preguntas en el banco para este grupo. ")
                              ], 64))
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("label", _hoisted_21, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: todosBancoSeleccionados.value,
                              onChange: toggleTodosBanco
                            }, null, 40, _hoisted_22),
                            _createTextVNode(" Seleccionar todo (" + _toDisplayString(bancoCompatible.value.length) + ") ", 1)
                          ]),
                          _createElementVNode("ul", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bancoCompatible.value, (b) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: b.id_pregunta,
                                class: "item-banco"
                              }, [
                                _createElementVNode("label", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    value: b.id_pregunta,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((bancoSeleccionado).value = $event))
                                  }, null, 8, _hoisted_24), [
                                    [_vModelCheckbox, bancoSeleccionado.value]
                                  ]),
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(b.enunciado || b.pregunta), 1)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm guardar",
                            disabled: !bancoSeleccionado.value.length,
                            onClick: importarDelBanco
                          }, " Agregar " + _toDisplayString(bancoSeleccionado.value.length || '') + " del banco ", 9, _hoisted_26)
                        ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Preguntas", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm guardar",
                disabled: mostrandoBorrador.value,
                onClick: abrirBorrador
              }, "+ Pregunta", 8, _hoisted_29)
            ]),
            (mostrandoBorrador.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", { class: "pregunta-head" }, [
                    _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Nueva pregunta", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-quitar",
                      onClick: cerrarBorrador
                    }, "✕")
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", null, "Enunciado", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((borrador.enunciado) = $event)),
                      type: "text",
                      placeholder: "¿En cuánto calificaría…?"
                    }, null, 512), [
                      [_vModelText, borrador.enunciado]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", null, "Tipo de respuesta", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((borrador.tipo_respuesta) = $event))
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "— Seleccionar tipo —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposDisponibles.value, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: t.valor,
                          value: t.valor
                        }, _toDisplayString(t.etiqueta), 9, _hoisted_33))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, borrador.tipo_respuesta]
                    ])
                  ]),
                  (requiereOpciones(borrador.tipo_respuesta))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Opciones (una por línea, mínimo 2)", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((borrador.opcionesTexto) = $event)),
                          rows: "3",
                          placeholder: "Totalmente de acuerdo\nDe acuerdo\nEn desacuerdo"
                        }, null, 512), [
                          [_vModelText, borrador.opcionesTexto]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (gruposSeleccionados.value.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Destinatarios de esta pregunta", -1)),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              value: true,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((borrador.general) = $event))
                            }, null, 512), [
                              [_vModelRadio, borrador.general]
                            ]),
                            _cache[27] || (_cache[27] = _createTextVNode(" Todos los grupos"))
                          ]),
                          _createElementVNode("label", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              value: false,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((borrador.general) = $event))
                            }, null, 512), [
                              [_vModelRadio, borrador.general]
                            ]),
                            _cache[28] || (_cache[28] = _createTextVNode(" Solo estos:"))
                          ])
                        ]),
                        (!borrador.general)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSeleccionados.value, (id) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: id,
                                  class: "grupo-check-mini"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    value: id,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((borrador.gruposDestino) = $event))
                                  }, null, 8, _hoisted_40), [
                                    [_vModelCheckbox, borrador.gruposDestino]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(nombreGrupo(id)), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm guardar",
                      disabled: !borrador.enunciado.trim() || !borrador.tipo_respuesta,
                      onClick: confirmarBorrador
                    }, "Agregar", 8, _hoisted_42)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!preguntas.value.length && !mostrandoBorrador.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, "Agrega al menos una pregunta."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preguntas.value, (p, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "pregunta-card"
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("strong", null, "Pregunta " + _toDisplayString(i + 1), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-quitar",
                    onClick: ($event: any) => (preguntas.value.splice(i, 1))
                  }, "✕", 8, _hoisted_45)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", null, "Enunciado", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((p.enunciado) = $event),
                    type: "text",
                    placeholder: "¿En cuánto calificaría…?"
                  }, null, 8, _hoisted_47), [
                    [_vModelText, p.enunciado]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", null, "Tipo de respuesta", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((p.tipo_respuesta) = $event),
                    disabled: tiposDisponibles.value.length === 1,
                    onChange: ($event: any) => (alCambiarTipoPregunta(p))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposDisponibles.value, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.valor,
                        value: t.valor
                      }, _toDisplayString(t.etiqueta), 9, _hoisted_50))
                    }), 128))
                  ], 40, _hoisted_49), [
                    [_vModelSelect, p.tipo_respuesta]
                  ])
                ]),
                (requiereOpciones(p.tipo_respuesta))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", null, "Opciones (una por línea, mínimo 2)", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": ($event: any) => ((p.opcionesTexto) = $event),
                        rows: "3",
                        placeholder: "Totalmente de acuerdo\nDe acuerdo\nEn desacuerdo"
                      }, null, 8, _hoisted_52), [
                        [_vModelText, p.opcionesTexto]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (gruposSeleccionados.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", null, "Destinatarios", -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: true,
                            "onUpdate:modelValue": ($event: any) => ((p.general) = $event)
                          }, null, 8, _hoisted_56), [
                            [_vModelRadio, p.general]
                          ]),
                          _cache[33] || (_cache[33] = _createTextVNode(" Todos los grupos"))
                        ]),
                        _createElementVNode("label", _hoisted_57, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: false,
                            "onUpdate:modelValue": ($event: any) => ((p.general) = $event)
                          }, null, 8, _hoisted_58), [
                            [_vModelRadio, p.general]
                          ]),
                          _cache[34] || (_cache[34] = _createTextVNode(" Solo estos:"))
                        ])
                      ]),
                      (!p.general)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSeleccionados.value, (id) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: id,
                                class: "grupo-check-mini"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: id,
                                  "onUpdate:modelValue": ($event: any) => ((p.gruposDestino) = $event)
                                }, null, 8, _hoisted_60), [
                                  [_vModelCheckbox, p.gruposDestino]
                                ]),
                                _createTextVNode(" " + _toDisplayString(nombreGrupo(id)), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (gruposSeleccionados.value.length && preguntas.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _cache[36] || (_cache[36] = _createElementVNode("p", { class: "resumen-titulo" }, "Distribución de preguntas por grupo", -1)),
                _createElementVNode("ul", _hoisted_62, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSeleccionados.value, (id) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: id,
                      class: _normalizeClass(['resumen-item', { 'resumen-item--vacio': contarPreguntasPorGrupo(id) === 0 }])
                    }, [
                      _createTextVNode(_toDisplayString(nombreGrupo(id)) + ": " + _toDisplayString(contarPreguntasPorGrupo(id)) + " pregunta(s) ", 1),
                      (contarPreguntasPorGrupo(id) === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "sin preguntas — no se puede guardar"))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(MensajeFlotante, {
            visible: mensajeVisible.value,
            mensaje: mensajeTexto.value,
            tipo: mensajeTipo.value,
            onCerrar: _cache[12] || (_cache[12] = ($event: any) => (mensajeVisible.value = false))
          }, null, 8, ["visible", "mensaje", "tipo"]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", {
              class: "btn salir",
              disabled: guardando.value,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('cerrar')))
            }, "Cancelar", 8, _hoisted_65),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: guardando.value || !puedeGuardar.value,
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Creando…' : 'Crear formulario'), 9, _hoisted_66)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})